// extracted by mini-css-extract-plugin
export default {"copy":"CopyToClipboard_copy__XFM5T"};